import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-704a8d5b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "starToggle",
  src: "/assets/icon/star_b.png"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" | ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_ag_text_s = _resolveComponent("ag-text-s")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preparesPartnerships, (item) => {
    return (_openBlock(), _createBlock(_component_ag_box_s, {
      key: item.stockItemId,
      css: {
      dp: '20px', borderBottom:'1px solid #F9F9FB', mb: '15px',
      pb: '15px', dp: 'flex', alignItems:'center', dd:'row',
      justifyContent: 'space-between',
    },
      onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'공동구매 열기', 'clickContent':item.stockItemName});_ctx.useCompanyModal(item.stockItemId, 'clubdeal')}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box_s, { css: {width:50} }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_box_s, { css: {
          width: '44px !important',
          height: '44px !important',
          position: 'relative',
        } }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  class: "img-circle img-responsive",
                  src: item.companyLogo ? item.companyLogo : '/assets/icon/company_default_img.png',
                  onerror: "this.src='/assets/icon/company_default_img.png'",
                  style: {"flex-shrink":"0"}
                }, null, 8, _hoisted_1),
                _hoisted_2
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_ag_box_s, { css: {
        minWidth:'180px',
      } }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_box_s, { css: {
          typography:'text17m',
        } }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.stockItemName), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_ag_box_s, { css: {
          typography:'text12r',
          color:'gray3',
          dp:'flex',
          dd:'row',
        } }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_box_s, { css: {
            mr:'4px',
            width:'12px',
            height:'12px',
            lineHeight: '17px',
          } }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_text_s, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.stockItemLikeCount), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_ag_text_s, { css: {
            mx:'4px',
            color:'bg2',
          } }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_text_s, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" 매물 " + _toDisplayString(_ctx.$filters.currency(item.partnershipCount)) + "개 ", 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_ag_box_s, {
          css: {
        textAlign:'right',
        typography:'text14r',
        dp:'block',
        color: (Number(item.sellCount)===0?'gray4':'black'),
        minWidth:'90px',
      }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_text_s, { css: {
          dp:'block'
        } }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$filters.currency(item.minPurchasePrice)) + " 원 ", 1)
              ]),
              _: 2
            }, 1024),
            (item.minPurchasePrice!=item.maxPurchasePrice)
              ? (_openBlock(), _createBlock(_component_ag_text_s, {
                  key: 0,
                  css: {
          dp:'block'
        }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" ~ " + _toDisplayString(_ctx.$filters.currency(item.maxPurchasePrice)) + " 원 ", 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["css"])
      ]),
      _: 2
    }, 1032, ["onClick"]))
  }), 128))
}